import { useHistory } from 'react-router-dom'
import { iconChevronLeft } from 'components/Icons'

import styles from './BackButton.module.sass'

const BackButton = () => {
  const history = useHistory()

  return (
    <button
      className={styles.back}
      onClick={() => history.goBack()}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') history.goBack()
      }}
    >
      <p className={styles.backTxt}>
        {iconChevronLeft({
          style: {
            height: '12px',
            width: '7px',
            color: '#979797',
            marginRight: '4.3px'
          }
        })}
        Back
      </p>
    </button>
  )
}

export default BackButton
